import { create } from "zustand";
import { getTokenValid } from "../api/userManagementAPI";

export const useUserStore = create((set, get) => ({
  isUserLoggedIn: false,
  userInfo: null,
  accessToken: null,

  // 로그인 상태 설정
  setIsUserLoggedIn: (value) => set({ isUserLoggedIn: value }),

  // 사용자 정보 설정
  setUserInfo: (userInfo) => set({ userInfo }),

  // 토큰 설정
  setAccessToken: (token) => set({ accessToken: token }),

  // 로그인 처리
  login: (token, userInfo) => {
    localStorage.setItem("accessToken", token);
    set({
      isUserLoggedIn: true,
      accessToken: token,
      userInfo,
    });
  },

  // 로그아웃 처리
  logout: () => {
    localStorage.removeItem("accessToken");
    set({
      isUserLoggedIn: false,
      accessToken: null,
      userInfo: null,
    });
  },

  // 토큰 유효성 검사
  checkAuthStatus: async () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      try {
        // const response = await getTokenValid();
        const response = {
          success: true,
        };
        if (response.success === true) {
          set({
            isUserLoggedIn: true,
            accessToken: token,
          });
          return true;
        } else {
          set({
            isUserLoggedIn: false,
            accessToken: null,
            userInfo: null,
          });
          return false;
        }
      } catch (error) {
        console.error("토큰 유효성 검증 실패:", error);
        return false;
      }
    } else {
      set({
        isUserLoggedIn: false,
        accessToken: null,
        userInfo: null,
      });
      return false;
    }
  },

  // 초기화 시 토큰 복원
  initializeAuth: () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      set({
        isUserLoggedIn: true,
        accessToken: token,
      });
    } else {
      set({
        isUserLoggedIn: false,
        accessToken: null,
        userInfo: null,
      });
    }
  },
}));

// 타일셋 상태 관리
export const useTilesetStore = create((set) => ({
  isTilesetLoaded: false,
  setIsTilesetLoaded: (value) => set({ isTilesetLoaded: value }),
  ViwerState: true,
  setViwerState: (value) => set({ ViwerState: value }),
  tilesetUrl: null,
  setTilesetUrl: (value) => set({ tilesetUrl: value }),
}));

// 포인트 선택 상태 관리
export const usePointStore = create((set, get) => ({
  projectId: null,
  setProjectId: (value) => set({ projectId: value }),

  fileId: null,
  setFileId: (value) => set({ fileId: value }),
  // 포트리 소스 URL 관리
  potreeUrl: null,
  setPotreeUrl: (value) => set({ potreeUrl: value }),
  // 포트리 뷰어 관리
  viewer: null,
  setViewer: (viewer) => set({ viewer }),

  // 포인트 좌표
  startPoint: null,
  endPoint: null,

  // 장애물 폴리곤 관리 (통합)
  obstacles: [], // 모든 장애물 폴리곤들 (완성/미완성 포함)

  // 완성된 장애물 객체들
  obstacleObjects: [],

  // 선택된 장애물 ID
  selectedObstacleId: null,

  // 경로 찾기 상태
  generatedPath: [],
  isPathVisible: false,
  pathMode: null,

  // 선택 모드 상태
  selectionMode: "none", // "none", "start", "end", "obstacle"

  // 장애물 모달 관리
  obstacleModal: false,

  // 맵 경계 관리
  mapBounds: null,

  // 액션들
  setStartPoint: (point) => set({ startPoint: point }),
  setEndPoint: (point) => set({ endPoint: point }),

  // 장애물 폴리곤 관련 액션들
  setObstacles: (points) => set({ obstacles: [points] }),

  clearAllObstacles: () => set({ obstacles: [] }),

  // 장애물 객체 저장
  setObstacleObject: (obstacleData) =>
    set((state) => ({
      obstacleObjects: [...state.obstacleObjects, obstacleData],
    })),

  removeObstacleObject: (id) =>
    set((state) => ({
      obstacleObjects: state.obstacleObjects.filter((obs) => obs.id !== id),
      selectedObstacleId:
        state.selectedObstacleId === id ? null : state.selectedObstacleId,
    })),

  clearAllObstacleObjects: () =>
    set({ obstacleObjects: [], selectedObstacleId: null }),

  // 선택된 장애물 관리
  setSelectedObstacleId: (id) => set({ selectedObstacleId: id }),

  // 경로 찾기 액션들
  setGeneratedPath: (path) => set({ generatedPath: path, isPathVisible: true }),
  clearPath: () => set({ generatedPath: [], isPathVisible: false }),
  setPathMode: (mode) => set({ pathMode: mode }),

  setSelectionMode: (mode) => set({ selectionMode: mode }),

  // 포인트 선택 완료 시 호출
  completePointSelection: (point) => {
    const {
      selectionMode,
      setStartPoint,
      setEndPoint,
      setSelectionMode,
      addToCurrentObstacle,
    } = get();

    if (selectionMode === "start") {
      setStartPoint(point);
      setSelectionMode("none");
    } else if (selectionMode === "end") {
      setEndPoint(point);
      setSelectionMode("none");
    } else if (selectionMode === "obstacle") {
      addToCurrentObstacle(point);
    }
  },

  // 선택 모드 초기화
  resetSelectionMode: () => set({ selectionMode: "none" }),

  // 장애물 모달 관리
  setObstacleModal: (value) => set({ obstacleModal: value }),
  obstacleInfo: null,
  setObstacleInfo: (value) => set({ obstacleInfo: value }),

  // 맵 경계 관리
  setMapBounds: (bounds) => set({ mapBounds: bounds }),
}));

export const useLoadingStore = create((set) => ({
  isLoadingViewer: false,
  loadingText: "로딩중...",

  showLoading: (text) => set({ isLoadingViewer: true, loadingText: text }),
  hideLoading: () => set({ isLoadingViewer: false, loadingText: "" }),
}));

export const vehicleSpecs = {
  1: {
    name: "운반: Burro",
    // 운반: Burro
    width: 0.92, // 실제 스펙: 36.25 in ≈ 92.07 cm ≈ 0.92 m :contentReference[oaicite:0]{index=0}
    wheelbaseL: 1.39, // 추정: 길이 1.39 m (54.7 in ≈ 138.9 cm), 거의 바퀴 간 거리로 가정 :contentReference[oaicite:1]{index=1}
    steerDeg: 360, // 버로는 각 바퀴 독립 구동 + 360도 회전 가능(skid steer) :contentReference[oaicite:2]{index=2}
  },
  2: {
    // 운반: LEVA
    name: "운반: LEVA",
    width: 1.2, // 추정: 소형 운반 플랫폼 수준 (~1.2m)
    wheelbaseL: 1.5, // 추정
    steerDeg: 30, // 추정: 제한적인 조향 가능한 플랫폼
  },
  3: {
    // 방제: LJ Tech Orchard Autonomous Sprayer S1000
    name: "방제: LJ Tech Orchard Autonomous Sprayer S1000",
    width: 2.5, // 추정: 과수원용 스프레이 장비, 붐까지 포함 시 너비 약 2.5m
    wheelbaseL: 2.0, // 추정
    steerDeg: 30, // 추정: 넓은 작업폭 / 조향 각도 필요
  },
  4: {
    // 방제: Yanmar YV01 Vineyard Spraying Robot
    name: "방제: Yanmar YV01 Vineyard Spraying Robot",
    width: 1.53, // 실제 스펙: overall width 1,530 mm :contentReference[oaicite:3]{index=3}
    wheelbaseL: 2.24, // 실제 스펙: overall length 2,240 mm (바퀴 간 길이로 추정) :contentReference[oaicite:4]{index=4}
    steerDeg: 180, // 추정: 좌·우 크롤러 개별 구동으로 넓은 회전 가능
  },
  5: {
    // 두둑 성형: WR Series Ridger
    name: "두둑 성형: WR Series Ridger",
    width: 1.5, // 추정: 두둑 폭 1.5m
    wheelbaseL: 2.5, // 추정: 트랙터 부착형으로 중간 정도
    steerDeg: 25, // 추정: 둑 형성을 위한 적절한 조향 가능성
  },
  6: {
    // 두둑 성형: Ridger – Hansen Engineering Works
    name: "두둑 성형: Ridger – Hansen Engineering Works",
    width: 1.6, // 추정
    wheelbaseL: 2.6, // 추정
    steerDeg: 25, // 추정
  },
};

export const usePathStore = create((set) => ({
  areaModeIdList: [],
  setAreaModeIdList: (idList) => set({ areaModeIdList: idList }),

  pathData: null,
  setPathData: (data) => set({ pathData: data }),

  waypoints: [],
  setWaypoints: (waypoints) => set({ waypoints }),

  equipmentWaypoints: {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  },

  setEquipmentWaypoints: (equipmentId, waypoints) =>
    set((state) => ({
      equipmentWaypoints: {
        ...state.equipmentWaypoints,
        [equipmentId]: waypoints,
      },
    })),

  // Potree 뷰어 인스턴스 관리
  viewer: null,
  setViewer: (viewer) => set({ viewer }),

  // 경로 수정 모드
  pathEditMode: false,
  setPathEditMode: (mode) => set({ pathEditMode: mode }),

  // 경로 생성 모드
  pathGenerateMode: false,
  setPathGenerateMode: (mode) => set({ pathGenerateMode: mode }),

  // 장애물 모드
  obstacleMode: false,
  setObstacleMode: (mode) => set({ obstacleMode: mode }),

  // 장애물 모달
  obstacleModal: false,
  setObstacleModal: (mode) => set({ obstacleModal: mode }),

  // 오버레이 메시지
  overlayMessage: "",
  setOverlayMessage: (message) => set({ overlayMessage: message }),

  // 오버레이 표시 여부
  showOverlay: false,
  setShowOverlay: (value) => set({ showOverlay: value }),

  // 장애물 폴리곤 좌표
  eachObstaclePoints: [],
  setEachObstaclePoints: (points) => set({ eachObstaclePoints: points }),

  // 전체 장애물 좌표
  allObstaclePoints: [],
  setAllObstaclePoints: (points) => set({ allObstaclePoints: points }),

  // 장애물 리스트 제거
  removeAllObstacleObject: (id) =>
    set((state) => ({
      allObstaclePoints: state.allObstaclePoints.filter((obs) => obs.id !== id),
    })),

  // 장애물 완성 좌표 관리
  closedObstacleArea: [],
  setClosedObstacleArea: (areas) => set({ closedObstacleArea: areas }),

  nodes: [],
  setNodes: (nodes) => set({ nodes }),

  markers: [],
  setMarkers: (markers) => set({ markers }),

  edges: [],
  setEdges: (edges) => set({ edges }),

  ribbonMeshs: [],
  setRibbonMeshs: (ribbonMeshs) => set({ ribbonMeshs }),

  polyline: null,
  setPolyline: (polyline) => set({ polyline }),

  ribbonMesh: null,
  setRibbonMesh: (ribbonMesh) => set({ ribbonMesh }),

  // 농기구 선택
  vehicleSpec: vehicleSpecs.equipment1,
  setVehicleSpec: (spec) => set({ vehicleSpec: spec }),

  selectedEquipmentId: 1,
  setSelectedEquipmentId: (id) => set({ selectedEquipmentId: id }),

  equipmentPaths: {
    1: {
      markers: [],
      nodes: [],
      edges: [],
      ribbonMeshs: [],
      polyline: null,
      ribbonMesh: null,
    },
    2: {
      markers: [],
      nodes: [],
      edges: [],
      ribbonMeshs: [],
      polyline: null,
      ribbonMesh: null,
    },
    3: {
      markers: [],
      nodes: [],
      edges: [],
      ribbonMeshs: [],
      polyline: null,
      ribbonMesh: null,
    },
    4: {
      markers: [],
      nodes: [],
      edges: [],
      ribbonMeshs: [],
      polyline: null,
      ribbonMesh: null,
    },
    5: {
      markers: [],
      nodes: [],
      edges: [],
      ribbonMeshs: [],
      polyline: null,
      ribbonMesh: null,
    },
    6: {
      markers: [],
      nodes: [],
      edges: [],
      ribbonMeshs: [],
      polyline: null,
      ribbonMesh: null,
    },
  },

  validEquipmentPaths: {},
  setValidEquipmentPaths: (paths) => set({ validEquipmentPaths: paths }),

  updateEquipmentPath: (equipmentId, pathData) =>
    set((state) => ({
      equipmentPaths: {
        ...state.equipmentPaths,
        [equipmentId]: {
          ...state.equipmentPaths[equipmentId], // 기존 데이터 유지
          ...pathData, // 새로운 데이터로 덮어쓰기
        },
      },
    })),

  hideAllEquipmentMarkers: () =>
    set((state) => {
      const updatedPaths = {};

      // 모든 장비 ID (1~6)에 대해 반복
      Object.keys(state.equipmentPaths).forEach((equipmentId) => {
        const currentPath = state.equipmentPaths[equipmentId];

        // 해당 장비의 모든 마커 숨기기
        if (currentPath.markers && currentPath.markers.length > 0) {
          currentPath.markers.forEach((marker) => {
            if (marker && marker.visible !== undefined) {
              marker.visible = false;
            }
          });
        }

        updatedPaths[equipmentId] = currentPath;
      });

      return {
        equipmentPaths: updatedPaths,
      };
    }),

  showAllEquipmentMarkers: () =>
    set((state) => {
      Object.keys(state.equipmentPaths).forEach((equipmentId) => {
        const currentPath = state.equipmentPaths[equipmentId];
        currentPath.markers?.forEach((marker) => {
          if (marker) marker.visible = true;
        });
      });
      return state;
    }),

  showEquipmentMarkers: (targetEquipmentId) =>
    set((state) => {
      const updatedPaths = {};

      Object.keys(state.equipmentPaths).forEach((equipmentId) => {
        const currentPath = state.equipmentPaths[equipmentId];

        if (currentPath.markers && currentPath.markers.length > 0) {
          currentPath.markers.forEach((marker) => {
            if (marker && marker.visible !== undefined) {
              // 타겟 장비만 보이게, 나머지는 숨기기
              marker.visible = equipmentId === targetEquipmentId;
            }
          });
        }

        updatedPaths[equipmentId] = currentPath;
      });

      return {
        equipmentPaths: updatedPaths,
      };
    }),

  resetEquipmentPath: (equipmentId) =>
    set((state) => ({
      equipmentPaths: {
        ...state.equipmentPaths, // 기존 데이터 유지
        [equipmentId]: {
          // 선택된 농기구만 초기화
          markers: [],
          nodes: [],
          edges: [],
          ribbonMeshs: [],
          polyline: null,
          ribbonMesh: null,
        },
      },
    })),

  // updatePolyLine 함수 자체
  updatePolyLine: null,
  setUpdatePolyLine: (func) => set({ updatePolyLine: func }),
}));

// 커스텀 알림 모달 상태 관리
export const useCustomAlertStore = create((set) => ({
  // 모달 표시 상태
  isCustomAlertOpen: false,
  setIsCustomAlertOpen: (value) => set({ isCustomAlertOpen: value }),

  // 알림 내용
  alertTitle: "",
  alertMessage: "",
  alertType: "warning", // "success", "error", "warning", "info"

  // 알림 내용 설정 함수들
  setAlertTitle: (title) => set({ alertTitle: title }),
  setAlertMessage: (message) => set({ alertMessage: message }),
  setAlertType: (type) => set({ alertType: type }),

  // 콜백 함수들
  onConfirm: null,
  onCancel: null,
  setOnConfirm: (callback) => set({ onConfirm: callback }),
  setOnCancel: (callback) => set({ onCancel: callback }),

  // 버튼 설정
  showCancelButton: true,
  confirmText: "확인",
  cancelText: "취소",
  setShowCancelButton: (value) => set({ showCancelButton: value }),
  setConfirmText: (text) => set({ confirmText: text }),
  setCancelText: (text) => set({ cancelText: text }),

  // 알림 모달 초기화
  resetAlert: () =>
    set({
      isCustomAlertOpen: false,
      alertTitle: "",
      alertMessage: "",
      alertType: "warning",
      onConfirm: null,
      onCancel: null,
      showCancelButton: true,
      confirmText: "확인",
      cancelText: "취소",
    }),

  // 편의 함수들 - 자주 사용하는 알림 패턴들
  showSuccessAlert: (title, message, onConfirm = null) =>
    set({
      isCustomAlertOpen: true,
      alertTitle: title,
      alertMessage: message,
      alertType: "success",
      onConfirm,
      showCancelButton: false,
      confirmText: "확인",
    }),

  showErrorAlert: (title, message, onConfirm = null) =>
    set({
      isCustomAlertOpen: true,
      alertTitle: title,
      alertMessage: message,
      alertType: "error",
      onConfirm,
      showCancelButton: false,
      confirmText: "확인",
    }),

  showWarningAlert: (title, message, onConfirm = null, onCancel = null) =>
    set({
      isCustomAlertOpen: true,
      alertTitle: title,
      alertMessage: message,
      alertType: "warning",
      onConfirm,
      onCancel,
      showCancelButton: true,
      confirmText: "확인",
      cancelText: "취소",
    }),

  showInfoAlert: (title, message, onConfirm = null) =>
    set({
      isCustomAlertOpen: true,
      alertTitle: title,
      alertMessage: message,
      alertType: "info",
      onConfirm,
      showCancelButton: false,
      confirmText: "확인",
    }),

  showConfirmAlert: (title, message, onConfirm, onCancel = null) =>
    set({
      isCustomAlertOpen: true,
      alertTitle: title,
      alertMessage: message,
      alertType: "warning",
      onConfirm,
      onCancel,
      showCancelButton: true,
      confirmText: "확인",
      cancelText: "취소",
    }),
}));

export const useSearchStore = create((set) => ({
  isSearchOpen: false,
  setIsSearchOpen: (value) => set({ isSearchOpen: value }),
  // 입력값 및 제어
  query: "",
  setQuery: (value) => set({ query: value }),
  // 버튼 텍스트
  confirmText: "확인",
  cancelText: "취소",
  setConfirmText: (text) => set({ confirmText: text }),
  setCancelText: (text) => set({ cancelText: text }),
  // 콜백
  onConfirm: null,
  onCancel: null,
  setOnConfirm: (cb) => set({ onConfirm: cb }),
  setOnCancel: (cb) => set({ onCancel: cb }),
  // 초기화
  reset: () =>
    set({
      isSearchOpen: false,
      query: "",
      confirmText: "확인",
      cancelText: "취소",
      onConfirm: null,
      onCancel: null,
    }),

  searchResult: null,
  setSearchResult: (result) => set({ searchResult: result }),
}));

export const usePotreeStore = create((set) => ({
  zStatsStore: null,
  setZStatsStore: (stats) => set({ zStatsStore: stats + 1.7 }),
}));

// 영역 생성 모달 상태 관리
export const useAreaGenerateStore = create((set, get) => ({
  selectedAreaColor: null,
  setSelectedAreaColor: (color) => set({ selectedAreaColor: color }),

  loadedServerPolygon: null,
  setLoadedServerPolygon: (value) => set({ loadedServerPolygon: value }),

  selectedArea: null,
  setSelectedArea: (area) => set({ selectedArea: area }),
  resetSelectedArea: () => set({ selectedArea: null }),

  selectedAreaColor: "#ff1493",
  setSelectedAreaColor: (color) => set({ selectedAreaColor: color }),
  resetSelectedAreaColor: () => set({ selectedAreaColor: "#ff1493" }),

  isAddAreaModeOpen: false,
  setIsAddAreaModeOpen: (value) => set({ isAddAreaModeOpen: value }),

  isAreaGenerateOpen: false,
  setIsAreaGenerateOpen: (value) => set({ isAreaGenerateOpen: value }),

  // 작업 유형
  selectedWorkType: "pathGenerate", // "pathGenerate", "areaGenerate"
  setSelectedWorkType: (type) => set({ selectedWorkType: type }),
  isAreaGenerateMode: () => get().selectedWorkType === "areaGenerate",

  // 영역 유형 (areaGenerate일 때만 사용)
  selectedAreaType: null, // "newAreaGenerate", "pathGenerate", "unpathGenerate"
  setSelectedAreaType: (type) => set({ selectedAreaType: type }),

  // 입력값들
  Name: "",
  setName: (value) => set({ Name: value }),
  newAreaName: "",
  setNewAreaName: (value) => set({ newAreaName: value }),

  // 영역 색상
  areaColor: "#ff1493", // 기본 파란색
  setAreaColor: (color) => set({ areaColor: color }),

  // 버튼 텍스트
  confirmText: "저장",
  cancelText: "취소",
  setConfirmText: (text) => set({ confirmText: text }),
  setCancelText: (text) => set({ cancelText: text }),

  // 콜백
  onConfirm: null,
  onCancel: null,
  setOnConfirm: (cb) => set({ onConfirm: cb }),
  setOnCancel: (cb) => set({ onCancel: cb }),

  // 초기화
  reset: () =>
    set({
      isAreaGenerateOpen: false,
      selectedWorkType: "pathGenerate",
      selectedAreaType: "newAreaGenerate",
      Name: "",
      newAreaName: "",
      confirmText: "저장",
      cancelText: "취소",
      onConfirm: null,
      onCancel: null,
    }),
}));

// 경로 저장 모달 상태 관리
export const useSavePathStore = create((set) => ({
  autoPathData: null,
  setAutoPathData: (data) => set({ autoPathData: data }),

  isSaveAutoPathOpen: false,
  setIsSaveAutoPathOpen: (value) => set({ isSaveAutoPathOpen: value }),

  isSavePathOpen: false,
  setIsSavePathOpen: (value) => set({ isSavePathOpen: value }),

  // 입력값들
  pathTitle: "",
  pathDescription: "",
  setPathTitle: (value) => set({ pathTitle: value }),
  setPathDescription: (value) => set({ pathDescription: value }),

  // 버튼 텍스트
  confirmText: "저장",
  cancelText: "취소",
  setConfirmText: (text) => set({ confirmText: text }),
  setCancelText: (text) => set({ cancelText: text }),

  // 콜백
  onConfirm: null,
  onCancel: null,
  setOnConfirm: (cb) => set({ onConfirm: cb }),
  setOnCancel: (cb) => set({ onCancel: cb }),

  // 초기화
  reset: () =>
    set({
      isSavePathOpen: false,
      pathTitle: "",
      pathDescription: "",
      confirmText: "저장",
      cancelText: "취소",
      onConfirm: null,
      onCancel: null,
    }),
}));

export const useCesiumStore = create((set, get) => ({
  setPolygonArea: null,
  setPolygonArea: (value) => set({ polygonArea: value }),

  stopRatationFunction: null,
  setStopRatationFunction: (value) => set({ stopRatationFunction: value }),

  toggleButton: "areaGenerate",
  setToggleButton: (value) => set({ toggleButton: value }),
  // 영역 생성 모드 확인 (실시간 업데이트)
  isAreaGenerateMode: () => get().toggleButton === "areaGenerate",

  editMode: false,
  setEditMode: (value) => set({ editMode: value }),
  toggleEditMode: () => set((state) => ({ editMode: !state.editMode })),
  getEditMode: () => get().editMode,
  tooltip: {
    visible: false,
    x: 0,
    y: 0,
    content: null,
    pointPosition: null,
  },
  setTooltip: (value) => set({ tooltip: value }),

  allPoints: [],
  setAllPoints: (points) => set({ allPoints: points }),

  polygonModeIdList: [],
  setPolygonModeIdList: (idList) => set({ polygonModeIdList: idList }),

  // 포인트 삭제 함수 (외부에서 사용할 수 있도록)
  deletePoint: null,
  setDeletePoint: (deleteFunction) => set({ deletePoint: deleteFunction }),

  clearAllPoints: null,
  setClearAllPoints: (clearFunction) => set({ clearAllPoints: clearFunction }),

  // 포인트 삭제 (Store에서 직접 관리)
  removePoint: (index) =>
    set((state) => {
      const newPoints = state.allPoints.filter((_, i) => i !== index);
      // 인덱스를 0부터 다시 정렬
      const reindexedPoints = newPoints.map((point, newIndex) => ({
        ...point,
        index: newIndex,
      }));
      return { allPoints: reindexedPoints };
    }),
}));

// 다운로드 모달 관리 스토어
export const useDownloadModalStore = create((set) => ({
  isOpen: false,
  areaData: null,

  // 모달 열기
  openModal: (areaData) => set({ isOpen: true, areaData }),

  // 모달 닫기
  closeModal: () => set({ isOpen: false, areaData: null }),

  // 자동경로 다운로드 모달 관리
  isOpenAuto: false,
  areaDataAuto: null,

  // 모달 열기
  openModalAuto: (areaDataAuto) => set({ isOpenAuto: true, areaDataAuto }),

  // 모달 닫기
  closeModalAuto: () => set({ isOpenAuto: false, areaDataAuto: null }),
}));

export const useEventStore = create((set) => ({
  cancelObstacle: null,
  setCancelObstacle: (fn) => set({ cancelObstacle: fn }),
}));

export const useProjectMEditStore = create((set) => ({
  isProjectMEditOpen: false,
  setIsProjectMEditOpen: (value) => set({ isProjectMEditOpen: value }),
  projectManagerId: null,
  setProjectManagerId: (value) => set({ projectManagerId: value }),
  projectData: null,
  setProjectData: (value) => set({ projectData: value }),
}));
